(() => {
  const triggerSelector = 'a[href$="#shopifyReshowConsentBanner"]';
  const bannerScriptSelector = 'script[src*="/privacy-banner/storefront-banner.js"]';
  const bannerScriptSource = '/cdn/shopifycloud/privacy-banner/storefront-banner.js';

  const showShopifyPreferences = () => {
    if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
      privacyBanner.showPreferences();
      return;
    }

    const existingScript = document.querySelector(bannerScriptSelector);
    if (existingScript) {
      existingScript.addEventListener('load', showShopifyPreferences, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = bannerScriptSource;
    script.async = true;
    script.addEventListener('load', showShopifyPreferences, { once: true });
    document.head.appendChild(script);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest(triggerSelector);
      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showShopifyPreferences();
    },
    true
  );
})();
